exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#toast-container .toast {\n  display: grid;\n  grid-template-columns: 8fr 0.5fr;\n  grid-template-rows: repeat(2, 1fr);\n  grid-column-gap: 0;\n  grid-row-gap: 0;\n}\n\n#toast-container .toast-title {\n  grid-area: 1 / 1 / 2 / 1;\n}\n\n#toast-container .toast-message {\n  grid-area: 2 / 2 / 2 / 1;\n}\n\n#toast-container button.toast-close-button {\n  font-size: 0.889rem; /* theme.fonts.size.small */\n  grid-area: 1 / 2 / 3 / 3;\n  height: 100%;\n  top: 0;\n  right: 0;\n  font-weight: normal;\n}\n\n#toast-container button.toast-close-button:focus,\n#toast-container button.toast-close-button:hover {\n  color: #fff;\n}\n", ""]);

// exports
